import './ScrollTable.less';
import { array } from 'prop-types';
import { useEffect, useRef } from 'react';

export default function ScrollTable({ data, columns, dataIndex }) {
  const animationDivRef = useRef(null);
  const animationFunc = () => {
    animationDivRef.current?.style.setProperty('transform', 'translateY(0)');
  };
  useEffect(() => {
    if (data.length > 5) {
      animationDivRef.current?.style.setProperty('animation-duration', `${data.length * 2}s`);
      animationDivRef.current?.addEventListener('animationiteration', animationFunc);
    }
    return () => {
      animationDivRef.current?.removeEventListener('animationiteration', animationFunc);
    };
  }, [data]);
  return (
    <div>
      {/* 表头区域 */}
      <div className="scroll-table__header">
        {
          columns?.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>{item}</div>
          ))
        }
      </div>
      <div className="scroll-table__body">
        <div className="animation-carrier" ref={animationDivRef}>
          {
            data?.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className="scroll-table__row">
                <div>{item[dataIndex[0]]}</div>
                <div>{item[dataIndex[1]]}</div>
                <div>{item[dataIndex[2]]}</div>
                <div>
                  {item[dataIndex[3]]}
                  万元
                </div>
              </div>
            ))
          }
          {
            data.length > 5 && data?.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className="scroll-table__row">
                <div>{item[dataIndex[0]]}</div>
                <div>{item[dataIndex[1]]}</div>
                <div>{item[dataIndex[2]]}</div>
                <div>
                  {item[dataIndex[3]]}
                  万元
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

ScrollTable.propTypes = {
  data: array,
  columns: array,
  dataIndex: array,
};

ScrollTable.defaultProps = {
  data: [],
  columns: [],
  dataIndex: [],
};
